/* === Seashell: header hides on scroll down, reappears on scroll up (desktop + mobile, site-wide).
   The theme's native "on-scroll-up" sticky mode is inert with our pill-header customisations,
   so this implements the behaviour directly on the sticky header section.
   26 Aug: on the homepage (template-index) the BODY is the scroll container (overflow-y:auto),
   so window scroll events never fire there and the header never hid. Listen with capture on
   document (catches scrolls on any container) and read the max of the possible scroll tops. === */
(function () {
  /* Fixed px, NOT a percentage: on the homepage (header-transparent) the section wrapper is a
     0-height sticky shell with the pill absolutely positioned inside, so translateY(-130%)
     resolves to 0 and the header never moved there. -150px clears the pill on every template. */
  var css = '.shopify-section.header-section{transition:transform .28s ease}' +
            '.shopify-section.header-section.ss-header-hide{transform:translateY(-150px) !important}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function init() {
    var sec = document.querySelector('.shopify-section.header-section');
    if (!sec || sec.dataset.ssHideWired) return;
    sec.dataset.ssHideWired = '1';
    function getY() {
      return Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, document.body.scrollTop || 0);
    }
    var last = getY();
    var acc = 0;
    document.addEventListener('scroll', function () {
      var y = getY();
      var d = y - last;
      if (d === 0) return;
      last = y;
      if (y < 160) { sec.classList.remove('ss-header-hide'); acc = 0; return; }
      if ((d > 0) === (acc > 0)) { acc += d; } else { acc = d; }
      if (acc > 28) { sec.classList.add('ss-header-hide'); }
      else if (acc < -28) { sec.classList.remove('ss-header-hide'); }
    }, { capture: true, passive: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
